import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { applyEvent, SexFlug, Status } from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkButton from "../../components/atoms/TkButton";
import TkTable from "../../components/atoms/TkTable";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import TkSelectForm from "../../components/atoms/TkSelectForm";
import TkCheckbox from "../../components/atoms/TkCheckbox";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import {
  IAPI_APP016_Request,
  IAPI_INQ012_Request,
  IAPI_INQ013_Response,
} from "../../type/apiType";
import { TkGetCode } from "../../utils/TkGetCode";
import { changeAmountFormat } from "../../utils/useTools";
import "./_style.scss";
import { httpAPI_APP016, httpAPI_INQ012, httpAPI_INQ013 } from "./api/request";
import { funInfoBodyList, funTransferHistoryList } from "./hooks/useHooks";
import {
  fakeTableList,
  infoHeadTitleList,
  monthMapping,
  schema,
} from "./parts";
import _ from "lodash";

/**
 * SCRW070010 請求者確認
 * @return SCRW070010 請求者確認
 */
const SCRW070010 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const location = useLocation();
  const [status, setStatus] = useState<any>();
  const [corpApplyKbn, setCorpApplyKbn] = useState<any>("0");
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [resData, setResData] = useState<any>();
  const [bodyList, setBodyList] = useState<any>(); // bodyList
  const [memoData, setMemoData] = useState("");
  const [showButton, setShowButton] = useState<boolean>(false); // メモ表示
  const isKikou =
    state?.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const businessType = businessState.common?.businessType;
  const [memoCheck, setMemoCheck] = useState(false);
  const applyId = location.state?.applyId;
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState<any[]>([]);
  const [selectedMonthByYear, setSelectedMonthByYear] = useState<{
    [year: string]: any[];
  }>({});

  const handleInit = async () => {
    try {
      const res = await httpAPI_INQ013({
        applyId,
      });
      if (res.resultCd === "I0000") {
        // 処理履歴
        const bodyListData: any = [];
        res.statusList?.forEach((item: any) => {
          const data = [
            { children: item.managerName },
            { children: item.process },
            { children: item.createDate, align: "center" },
            { children: item.processComment },
          ];
          bodyListData.push(data);
        });
        setBodyList(bodyListData);

        let resArr = stateFakeTableList.current;

        if (businessType === "JOB-78") {
          resArr.find((item) => item.keyword === "title1")!.lineTitle =
            "被共済職員原簿閲覧請求";
        }
        if (businessType === "JOB-74") {
          resArr.find((item) => item.keyword === "title1")!.lineTitle =
            "退職手当金支給予定額の証明依頼";
        }
        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;
          if (targetObj) {
            if (
              [
                "salaryTableAmt",
                "salaryAdjustmentAmt",
                "sum",
                "paymentAmt",
              ].includes(i)
            ) {
              const value = res[i as keyof typeof res] as string | null;
              targetObj.text = value ? changeAmountFormat(value) + "円" : "";
            } else if (i === "corpName" && isKikou) {
              targetObj.text =
                businessState.common?.contractorNo +
                ":" +
                businessState.common?.contractorName;
              targetObj.showLine = true;
            } else if (i === "staffNameKanji") {
              targetObj.text =
                (res.staffNo ?? "") + ":" + (res.staffNameKanji ?? "");
            } else if (i === "sex") {
              targetObj.text = TkGetCode(SexFlug, res[i]);
            } else {
              targetObj.text = res[i as keyof typeof res] as string;
            }
          }
        }

        //在籍期間
        resArr.find((item) => item.keyword === "enroll")!.text = `${
          res.premiumEnrollYear ?? 0
        }年${res.premiumEnrollMonth ?? 0}ヶ月`;

        // 育休テーブル
        const infoBodyList = funInfoBodyList(res.childcareLeaveList);
        resArr.find((item) => item.keyword === "childcareLeaveList")!.node = (
          <Box className="childcareLeaveList">
            <TkTable bodyList={infoBodyList} headList={infoHeadTitleList} />
          </Box>
        );

        const transferHistoryList = funTransferHistoryList(
          res.transferHistoryList
        );
        const disabled =
          res.latestApplyStatus === Status["届出待ち"] ||
          res.latestApplyStatus === Status["差戻し一時保存"];
        resArr.find(
          (item) => item.keyword === "transferHistoryList"
        )!.dataList = transferHistoryList;
        //請求者のメールアドレス
        let email = resArr.find((item) => item.keyword === "email")!;
        email.setDefaultValue = res.demanderEmail;
        email.disabled = !disabled;
        //請求者のメールアドレス（確認用）
        let emailConfirm = resArr.find(
          (item) => item.keyword === "emailConfirm"
        )!;
        emailConfirm.setDefaultValue = res.demanderEmail;
        emailConfirm.disabled = !disabled;

        if (res.unrecognizedMonthList && res.unrecognizedMonthList.length > 0) {
          const lastItem =
            res.unrecognizedMonthList[res.unrecognizedMonthList.length - 1];
          const defaultYear =
            lastItem && lastItem.year ? lastItem.year.toString() : "";
          const defaultMonthsArr = Object.values(lastItem).slice(2);

          setSelectedYear(defaultYear);
          setSelectedMonth(defaultMonthsArr as any[]);
          setSelectedMonthByYear({ [defaultYear]: defaultMonthsArr });
        }

        setStateTableList([...resArr]);
        setStatus(res.latestApplyStatus);
        setShowButton(disabled);
        setResData(res);
        setCorpApplyKbn(res.corpApplyKbn);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ならない月
  const renderUnrecognizedMonthList = () => {
    let res: IAPI_INQ013_Response = _.cloneDeep(resData);
    if (!res) return null;

    const selectYears =
      resData.unrecognizedMonthList?.map((item: any) => ({
        value: item.year?.toString(),
        label: item.year?.toString() + "年",
      })) ?? [];

    return (
      <Box className="SCRC070004tblList">
        <Box className="part">
          <TkSelectForm
            selectPropsList={selectYears}
            wantToSetValue={selectedYear}
            onChange={(e: any) => {
              setSelectedYear(e.target.value);
              const newYear = e.target.value;
              const newMonthArr =
                res.unrecognizedMonthList?.find(
                  (item: any) => item.year === Number(newYear)
                ) ?? {};
              const savedMonthArr =
                selectedMonthByYear[newYear] ||
                Object.values(newMonthArr).slice(2);
              if (!_.isEqual(selectedMonth, savedMonthArr)) {
                setSelectedMonth(savedMonthArr);
              }
            }}
          />
        </Box>
        <Box>
          <TkCheckbox
            label="無"
            disabled
            checked={selectedMonth.every((m) => m === "0" || m === "2")}
            onChange={(e: any) => {
              const newMonthArr = selectedMonth.map(() =>
                e.target.checked ? "1" : "0"
              );
              setSelectedMonth(newMonthArr);
              setSelectedMonthByYear((prev) => ({
                ...prev,
                [selectedYear]: newMonthArr,
              }));
            }}
          />
          {Object.values(monthMapping).map((month: string, index: number) => {
            const checked =
              selectedMonth[index] === "1" || selectedMonth[index] === "3";
            return (
              <TkCheckbox
                key={index}
                label={`${month}月`}
                disabled
                checked={checked}
                onChange={(e: any) => {
                  changeMonth(index, e.target.checked);
                }}
              />
            );
          })}
        </Box>
      </Box>
    );
  };

  const changeMonth = (index: number, checked: boolean) => {
    const monthArr = [...selectedMonth];
    monthArr[index] = checked ? "1" : "0";
    setSelectedMonth(monthArr);
    setSelectedMonthByYear((prev) => ({
      ...prev,
      [selectedYear]: monthArr,
    }));
  };

  useEffect(() => {
    let newStateTableList = stateFakeTableList.current;
    newStateTableList.find(
      (item: any) => item.keyword === "unrecognizedMonthList"
    )!.node = renderUnrecognizedMonthList();
    setStateTableList([...newStateTableList]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resData, selectedYear, selectedMonth]);

  const makeHttpObjForUpdate = (obj: any): IAPI_INQ012_Request => {
    const reqObj: IAPI_INQ012_Request = {
      applyId,
      businessType: businessState.common?.businessType, // 		業務タイプ
      demanderNameKanji: resData.demanderNameKanji,
      demanderEmail: obj.email,
      demanderBirthday: resData.demanderBirthday, // 		職員照会問い合わせ.請求者生年月日
      demanderTel: resData.demanderTel, // 	職員照会問い合わせ.請求者電話番号
      contractorNo: businessState.common?.contractorNo,
      staffNo: resData.staffNo,
      demanderUserType: resData.demanderUserType, // 		請求者ユーザ.ユーザタイプ（9000:ユーザタイプ）
      screenId: "SCRW070010",
      deliveryZipcode: resData.deliveryZipcode, // 	申請等管理.通知書送付先住所（郵便番号）
      deliveryPrefectureCd: resData.deliveryPrefectureCd, // 	申請等管理.通知書送付先住所（都道府県）
      deliveryAddressCity: resData.deliveryAddressCity, // 	申請等管理.通知書送付先住所（市区町村）
      deliveryAddressOthers: resData.deliveryAddressOthers, // 	申請等管理.通知書送付先住所（その他）
    };
    return reqObj;
  };

  const onCheckAndSubmit = async (data: any) => {
    try {
      const res = await httpAPI_INQ012({
        ...makeHttpObjForUpdate(data),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  const ref = useRef<any>(null);
  // 登録ボタン用のイベント
  const handleResister = () => {
    ref.current.submit();
  };
  // 最新申請状態 が"00"(届出待ち)の以外場合（登録ボタン以外）
  const makeHttpObj = (num: string) => {
    const data: IAPI_APP016_Request = {
      applyId: applyId, //申請ID
      applyEvent: num, //申請イベント
      contractorNo: businessState.common?.contractorNo, //契約者番号
      reason: memoData, //メモ
      screenId: "SCRW070010", //画面ID
    };

    if (memoCheck) {
      data.inquiryCode = "3"; //照会画面への反映コード
    }
    return data;
  };

  const btnEvent = async (btnName: keyof typeof applyEvent) => {
    let applyEventNo = applyEvent[btnName];
    if (
      ![
        applyEvent["通知"],
        applyEvent["受理"],
        applyEvent["契約者に差戻し"],
        applyEvent["上長承認"],
        applyEvent["担当者に差戻し"],
        applyEvent["課長代理確認"],
        applyEvent["郵送"],
      ].includes(applyEventNo)
    )
      return;

    if (applyEventNo === applyEvent["担当者に差戻し"]) {
      if (status === "01" || status === "02") {
        applyEventNo = applyEvent["契約者に差戻し"];
      }
    }

    if (applyEventNo === applyEvent["通知"]) {
      // 通知ボタン押下時処理
      const stateData: any = {
        applyId: applyId,
        contractorNo: businessState.common?.contractorNo,
        screenId: "SCRW070010",
        memo: memoData,
      };

      if (memoCheck) {
        stateData.refInquiryScreen = "3";
      }
      navigate("/SCRW130001", { state: stateData });
      return;
    }

    try {
      const res = await httpAPI_APP016({
        ...makeHttpObj(applyEventNo),
      });

      if (res.resultCd === "I0000") {
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRW070010PageForTest" className="SCRW070010">
      {!showButton && (
        <Box>
          <TkKikoStepper
            applicationFlowType="TYPE3"
            businessType="JOB-78"
            applicationStatus={status}
            corporateApplicationClassification={corpApplyKbn}
          />
        </Box>
      )}

      <Box className="body">
        <TkFakeTable
          ref={ref}
          list={stateTableList}
          ruleSchema={schema}
          onCheckAndSubmit={onCheckAndSubmit}
          showButton={false}
        />

        {!showButton && (
          <TkMemo
            data-testid="SCRW070010-memo-test"
            onChange={onChange}
            bodyList={bodyList}
            showTable={isKikou}
          />
        )}
      </Box>
      <Box className="tkBottonBox">
        <TkBackButton mr />
        {showButton ? (
          <TkButton
            data-testid="SCRW070010ResisterButton"
            onClick={handleResister}
          >
            登録
          </TkButton>
        ) : (
          <TkViewButtonJudgement
            flowType="TYPE3"
            businessType="JOB-74"
            Status={status}
            onClick={btnEvent}
          />
        )}
      </Box>
    </Box>
  );
};

export default SCRW070010;
